// extracted by mini-css-extract-plugin
export var root = "Avatar-module--root--nMYBe";